<template>
  <div id="myquestion-list-card">
    <ul class="scrollList" slot="list">
      <li v-for="(item) of incomingList" v-bind:key="item.UserQuestionnaireID">
        <div class="box-body van-hairline--bottom clearfix">
          <h3>{{item.QuestionnaireName}}</h3>
        </div>
        <div class="box-footer">
          <div
            class="fl"
          >{{ new Date(item.StartTime.replace(/-/g, '/')).pattern('yyyy-MM-dd')}} 至 {{new Date(item.EndTime.replace(/-/g, '/')).pattern('yyyy-MM-dd')}}</div>
          <div class="fr">
            <!-- TODO: 针对下面过长的三元运算符，临时增加方法 submitStatus_btnText(item),暂且不用，有时间评估一下以此代替 -->
            <van-button
              type="primary"
              size="small"
              @click.native="answer(item)"
              v-bind:disabled="
                item.SubmitStatus ||
                  diff(item.CurrDate, 'd', item.StartTime) > 0 ||
                  diff(item.CurrDate, 'd', item.EndTime) < 0
              "
              >{{
                item.SubmitStatus
                  ? '已完成'
                  : diff(item.CurrDate, 'd', item.StartTime) > 0
                    ? '未开始'
                    : diff(item.CurrDate, 'd', item.EndTime) < 0
                      ? '已过时'
                      : '填写'
              }}</van-button
            >
          </div>
          <div style="clear:both"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {

    };
  },
  props: {
    incomingList: {
      default: []
    }
  },
  created: function() {},
  mounted: function() {
    // console.log(this.list);
  },
  methods: {
    async switchBtn(questionnaireid, PublishStauts) {
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          `/api/Questionnaire/Publish?QuestionnaireID=${questionnaireid}&publishStatus=${PublishStauts}`
      );
      if (res && res.success) {
        this.xy.msgSuc("更新成功！");
      } else {
        this.xy.msgError((res && res.msg) || "更新失败");
      }
    },
    answer(item) {
        let params = {
            questionnaireRow: item,
        }
        this.$router.push({path: '/home/questionnaireUserOptions', query: params})
    },
    diff(date, strInterval, dtEnd) {
      if (typeof dtEnd === "string") {
        //如果是字符串转换为日期型
        dtEnd = new Date(dtEnd.replace(/-/g, "/")); //StringToDate(dtEnd);
      }
      if (typeof date === "string") {
        //如果是字符串转换为日期型
        date = new Date(date.replace(/-/g, "/")); //StringToDate(dtEnd);
      }
      switch (strInterval) {
        case "s":
          return parseInt((dtEnd - date) / 1000);
        case "n":
          return parseInt((dtEnd - date) / 60000);
        case "h":
          return parseInt((dtEnd - date) / 3600000);
        case "d":
          return parseInt((dtEnd - date) / 86400000);
        case "w":
          return parseInt((dtEnd - date) / (86400000 * 7));
        case "m":
          return (
            dtEnd.getMonth() +
            1 +
            (dtEnd.getFullYear() - date.getFullYear()) * 12 -
            (date.getMonth() + 1)
          );
        case "y":
          return dtEnd.getFullYear() - date.getFullYear();
      }
    },
    // TODO: 临时方法，暂未启用，详见上方模板注释
    submitStatus_btnText(item) {
      if (item.SubmitStatus) {
        return '已完成'
      } else {
        if (this.diff(item.CurrDate, 'd', item.StartTime) > 0) {
          return '未开始'
        } else {
          if (this.diff(item.CurrDate, 'd', item.EndTime) < 0) {
            return '已过时'
          } else {
            return '填写'
          }
        }
      }
    }
  }
};
</script>
<style lang='less' >
#myquestion-list-card {
  .van-switch,
  .van-switch__node {
    float: right;
  }
  .scrollList {
    margin-top: 16px;
  }
  .box-body {
    border-bottom-color: #eee;
    padding: 24px 20px;
  }
  h3 {
    font-size: 32px;
    margin-bottom: 24px;
  }
  .box-footer {
    clear: both;
    padding: 20px;
  }
  li {
    margin-top: 20px;
    background-color: #fff;
  }
  .van-button--disabled {
    background-color: #999;
    color: #f0f0f0;
    border: none;
  }
}
</style>
